import { useState, useEffect } from 'react';

const usePersistentState = (key, defaultValue) => {
  const [state, setState] = useState(() => {
    const persistentState = localStorage.getItem(key);
    return persistentState ? JSON.parse(persistentState) : defaultValue;
  });

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(state));
  }, [key, state]);

  return [state, setState];
};

export default usePersistentState;
